document.addEventListener('DOMContentLoaded', function() {
    // Elements
    const elements = {
        applyBtn: document.getElementById('apply_discount_btn'),
        removeBtn: document.getElementById('remove_discount_btn'),
        input: document.getElementById('discount_code_input'),
        message: document.getElementById('discount_code_message'),
        tag: document.getElementById('applied_discount_tag'),
        tagText: document.getElementById('discount_tag_text')
    };
    
    // Get settings from mini-cart element or use defaults
    const miniCart = document.getElementById('mini-cart');
    const settings = {
        showItemsDiscount: miniCart?.dataset.showItemsDiscount === 'true' || true,
        showCouponDiscount: miniCart?.dataset.showCouponDiscount === 'true' || true,
        showDiscountTotal: miniCart?.dataset.showDiscountTotal === 'true' || false
    };
    
    // Check for active discounts on page load
    checkForActiveDiscounts();
    
    // Also check when the cart drawer opens
    document.addEventListener('drawerOpened', function(e) {
        if (e.detail && e.detail.drawer && e.detail.drawer.id === 'mini-cart') {
            checkForActiveDiscounts();
        }
    });
    
    // Bind event listeners
    if (elements.applyBtn) {
        elements.applyBtn.addEventListener('click', handleApplyDiscount);
    }
    
    if (elements.removeBtn) {
        elements.removeBtn.addEventListener('click', removeDiscountCode);
    }
    
    const discountTagRemove = document.getElementById('discount_tag_remove');
    if (discountTagRemove) {
        discountTagRemove.addEventListener('click', removeDiscountCode);
    }
    
    // Listen for cart:updated events from ApLineItemQuantity
    document.documentElement.addEventListener('cart:updated', function(e) {
        if (e.detail && e.detail.cart) {
            try {
                // Preserve the current tag state before update
                const tagWasVisible = elements.tag && elements.tag.style.display === 'inline-flex';
                const tagText = elements.tagText ? elements.tagText.textContent : '';
                
                // Preserve the discount section content
                preserveDiscountSection();
                
                updateCartDisplay(e.detail.cart);
                
                // If there was a discount tag and it disappeared, restore it temporarily
                // while we check if it should still be shown
                if (tagWasVisible && elements.tag && elements.tag.style.display !== 'inline-flex') {
                    elements.tag.style.display = 'inline-flex';
                    if (elements.tagText) elements.tagText.textContent = tagText;
                    
                    // Immediately check for active discounts to update properly
                    checkForActiveDiscounts();
                }
            } catch (error) {
                console.error('Error handling cart:updated event:', error);
                // Continue without crashing
            }
        }
    });
    
    // Also listen for cart:refresh events which might update the HTML
    document.documentElement.addEventListener('cart:refresh', function(e) {
        // Store the current tag state before refresh
        const tagWasVisible = elements.tag && elements.tag.style.display === 'inline-flex';
        const tagText = elements.tagText ? elements.tagText.textContent : '';
        
        // Preserve the discount section HTML
        preserveDiscountSection();
        
        // Store in sessionStorage to survive DOM changes
        if (tagWasVisible) {
            sessionStorage.setItem('discount_tag_visible', 'true');
            sessionStorage.setItem('discount_tag_text', tagText);
        }
        
        // After the cart content is refreshed, check for active discounts
        // Wait for the replacement delay mentioned in the event
        const delay = e.detail?.replacementDelay || 750;
        
        // Add an intermediate check to catch immediate changes
        setTimeout(() => {
            // Check if tag disappeared right after refresh but before our main callback
            const refreshTagExists = document.getElementById('applied_discount_tag');
            
            if (refreshTagExists && tagWasVisible) {
                refreshTagExists.style.display = 'inline-flex';
                const refreshTagText = document.getElementById('discount_tag_text');
                if (refreshTagText) refreshTagText.textContent = tagText;
            }
            
            // Restore the discount section if needed
            restoreDiscountSection();
        }, 50);
        
        setTimeout(() => {
            try {
                // Reload element references which might have changed during refresh
                elements.tag = document.getElementById('applied_discount_tag');
                elements.tagText = document.getElementById('discount_tag_text');
                elements.applyBtn = document.getElementById('apply_discount_btn');
                elements.removeBtn = document.getElementById('remove_discount_btn');
                elements.input = document.getElementById('discount_code_input');
                elements.message = document.getElementById('discount_code_message');
                
                // Check if we need to restore the tag from sessionStorage
                const storedTagVisible = sessionStorage.getItem('discount_tag_visible');
                const storedTagText = sessionStorage.getItem('discount_tag_text');
                
                if (storedTagVisible === 'true' && elements.tag) {
                    elements.tag.style.display = 'inline-flex';
                    if (elements.tagText) elements.tagText.textContent = storedTagText || 'Discount applied';
                }
                
                // Restore discount section one more time if needed
                restoreDiscountSection();
                
                checkForActiveDiscounts();
                
                // Clear sessionStorage after use
                sessionStorage.removeItem('discount_tag_visible');
                sessionStorage.removeItem('discount_tag_text');
            } catch (error) {
                console.error('Error in delayed checkForActiveDiscounts:', error);
                // Continue without crashing
            }
        }, delay);
    });
    
    // Watch for DOM changes that might affect the discount tag
    document.addEventListener('DOMContentLoaded', function() {
        // Set up a MutationObserver to watch for changes to the discount tag
        if ('MutationObserver' in window) {
            const tagObserver = new MutationObserver(function(mutations) {
                mutations.forEach(function(mutation) {
                    // If the tag's display style was changed to 'none', check if it should be visible
                    if (mutation.target.id === 'applied_discount_tag' && 
                        mutation.attributeName === 'style' && 
                        mutation.target.style.display === 'none') {
                        
                        // Check if we have an active discount
                        fetchCartContents().then(cart => {
                            if (cart.total_discount > 0) {
                                mutation.target.style.display = 'inline-flex';
                                
                                // Update the tag text if needed
                                const tagText = document.getElementById('discount_tag_text');
                                if (tagText && !tagText.textContent) {
                                    if (cart.discount_codes && cart.discount_codes.length > 0 && 
                                        cart.discount_codes[0].applicable !== false) {
                                        tagText.textContent = cart.discount_codes[0].code;
                                    } else {
                                        tagText.textContent = 'Automatic discount';
                                    }
                                }
                            }
                        }).catch(err => console.error('Error in tag observer:', err));
                    }
                });
            });
            
            // Start observing once the tag element exists
            const startObserver = function() {
                const tagElement = document.getElementById('applied_discount_tag');
                if (tagElement) {
                    tagObserver.observe(tagElement, { attributes: true });
                } else {
                    // Try again in a bit if the element doesn't exist yet
                    setTimeout(startObserver, 500);
                }
            };
            
            startObserver();
        }
        
        // Add a backup interval to periodically check discount status
        setInterval(function() {
            const tagElement = document.getElementById('applied_discount_tag');
            if (tagElement) {
                fetchCartContents().then(cart => {
                    if (cart.total_discount > 0 && tagElement.style.display !== 'inline-flex') {
                        tagElement.style.display = 'inline-flex';
                        
                        // Update the tag text if needed
                        const tagText = document.getElementById('discount_tag_text');
                        if (tagText) {
                            if (cart.discount_codes && cart.discount_codes.length > 0 &&
                                cart.discount_codes[0].applicable !== false) {
                                tagText.textContent = cart.discount_codes[0].code;
                            } else {
                                tagText.textContent = 'Automatic discount';
                            }
                        }
                    }
                }).catch(err => console.error('Error in backup interval:', err));
            }
        }, 3000); // Check every 3 seconds
    });
    
    // When a line item is removed, we need special handling
    document.body.addEventListener('click', function(e) {
        // Check if it's a cart line item remove button
        if (e.target.closest('.line-item__remove-button')) {
            // Add a flag to localStorage to indicate a removal is in progress
            localStorage.setItem('cart_item_removal_in_progress', 'true');
            
            // Clear the flag after a delay
            setTimeout(() => {
                localStorage.removeItem('cart_item_removal_in_progress');
            }, 2000);
        }
    });
    
    // Listen for DOMContentLoaded to add CSS
    const style = document.createElement('style');
    style.textContent = `
        .ajaxcart__discount-container {
            min-height: 10px; /* Small min-height */
            display: block; /* Ensure container is always present */
        }
        
        .ajaxcart__discount-line {
            display: flex;
            justify-content: space-between;
            margin-bottom: 4px;
        }
        
        .product-discount-line {
            color: var(--color-accent-1);
        }
        
        .coupon-discount-line {
            color: var(--color-accent-1);
        }
        
        .automatic-discount-line {
            color: #ee312b;
        }
        
        .discount-total-line {
            color: var(--primary-2);
            font-weight: bold;
            margin-top: 5px;
            border-top: 1px solid #e4e4e4;
            padding-top: 5px;
        }
        
        /* Hide elements with this class */
        .hidden-discount-line {
            display: none;
        }
        
        /* Clone container class for preserving state */
        .discount-clone-container {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            z-index: 1; /* Make it visible above the regular container */
            pointer-events: none;
        }
        
        /* Fade transition for discount container */
        .ajaxcart__footer-price {
            position: relative;
        }
    `;
    document.head.appendChild(style);
    
    // When the DOM is loaded, create all possible discount elements
    document.addEventListener('DOMContentLoaded', function() {
        // Create the discount container structure once
        setupDiscountContainer();
    });
    
    // Function to find or create the discount container with all possible lines
    function setupDiscountContainer() {
        const footerPriceContainer = document.querySelector('.ajaxcart__footer-price');
        if (!footerPriceContainer) return null;
        
        // Check if container already exists
        let discountContainer = footerPriceContainer.querySelector('.ajaxcart__discount-container');
        if (!discountContainer) {
            discountContainer = document.createElement('div');
            discountContainer.className = 'ajaxcart__discount-container';
            
            // Insert it before the subtotal
            try {
                const subtotalName = footerPriceContainer.querySelector('.ajaxcart__subtotal-name');
                if (subtotalName && subtotalName.parentNode) {
                    footerPriceContainer.insertBefore(discountContainer, subtotalName.parentNode);
                } else {
                    // If we can't find the subtotal, just put it at the beginning
                    footerPriceContainer.prepend(discountContainer);
                }
            } catch (e) {
                footerPriceContainer.prepend(discountContainer);
            }
            
            // Create all possible discount lines once
            createDiscountLine(discountContainer, 'product-discount-line', 'Product Discount');
            createDiscountLine(discountContainer, 'coupon-discount-line', 'Coupon Discount');
            createDiscountLine(discountContainer, 'automatic-discount-line', 'Automatic Discount');
            createDiscountLine(discountContainer, 'discount-total-line', 'Total Savings');
        }
        
        // Hide all lines initially
        const allLines = discountContainer.querySelectorAll('.ajaxcart__discount-line');
        allLines.forEach(line => {
            line.classList.add('hidden-discount-line');
        });
        
        return discountContainer;
    }
    
    // Helper to create a discount line
    function createDiscountLine(container, className, defaultLabel) {
        const line = document.createElement('div');
        line.className = `ajaxcart__discount-line ${className} hidden-discount-line`;
        
        const label = document.createElement('span');
        label.className = 'discount-label';
        label.textContent = defaultLabel;
        
        const amount = document.createElement('span');
        amount.className = 'discount-amount';
        amount.textContent = '-$0.00';
        
        line.appendChild(label);
        line.appendChild(amount);
        container.appendChild(line);
        
        return line;
    }
    
    // Update cart display with new data
    function updateCartDisplay(cartData) {
        if (!cartData) {
            console.error('Cart data is undefined in updateCartDisplay');
            return;
        }
        
        // If an item removal is in progress, delay the update
        if (localStorage.getItem('cart_item_removal_in_progress')) {
            setTimeout(() => updateCartDisplay(cartData), 500);
            return;
        }
        
        // Setup the container if it doesn't exist
        const footerPriceContainer = document.querySelector('.ajaxcart__footer-price');
        if (!footerPriceContainer) return;
        
        let discountContainer = footerPriceContainer.querySelector('.ajaxcart__discount-container');
        if (!discountContainer) {
            discountContainer = setupDiscountContainer();
        }
        
        if (!discountContainer) return;
        
        // Store current tag state and settings
        const tagWasVisible = elements.tag && elements.tag.style.display === 'inline-flex';
        const tagText = elements.tagText ? elements.tagText.textContent : '';
        
        // Get latest discount code - first try from cart data then from localStorage
        let savedDiscount = null;
        
        // Try to get discount code directly from cart data first (most reliable)
        if (cartData.discount_codes && cartData.discount_codes.length > 0) {
            // Filter out non-applicable discount codes and 'clear' codes
            const validDiscounts = cartData.discount_codes.filter(code => 
                code.applicable !== false && 
                code.code && 
                code.code.toLowerCase() !== 'clear'
            );
            
            if (validDiscounts.length > 0) {
                const firstDiscount = validDiscounts[0];
                if (firstDiscount && firstDiscount.code) {
                    savedDiscount = firstDiscount.code;
                }
            }
        }
        
        // If not found in cart data, use localStorage
        if (!savedDiscount) {
            savedDiscount = localStorage.getItem('shopify_discount_code');
        }
        
        // Special case: check if there's a discount applied but we don't have a valid code
        const hasDiscount = cartData.total_discount > 0;
        
        // Keep the discount tag visible if there's any discount, even if we don't have a specific code
        if (hasDiscount && !savedDiscount && tagWasVisible) {
            savedDiscount = tagText || 'Automatic discount';
        }
        
        // Only update the discount tag if we have an actual discount code (not automatic discounts)
        if (elements.tag && elements.tagText && savedDiscount) {
            // Only show the tag if there is a valid discount_code
            if (cartData.discount_codes && cartData.discount_codes.length > 0) {
                // Check if we have a valid discount code (not 'clear' and applicable)
                const hasValidDiscountCode = cartData.discount_codes.some(code => 
                    code.applicable !== false && 
                    code.code && 
                    code.code.toLowerCase() !== 'clear'
                );
                
                if (hasValidDiscountCode) {
                    // Look for the specific discount application related to the coupon code
                    const cartDiscounts = cartData.cart_level_discount_applications || [];
                    let couponDiscount = null;
                    
                    // Try to find the discount application that matches the coupon code
                    for (const discount of cartDiscounts) {
                        if (discount && discount.title && discount.title.toLowerCase().includes(savedDiscount.toLowerCase())) {
                            couponDiscount = discount;
                            break;
                        }
                    }
                    
                    if (couponDiscount && couponDiscount.total_allocated_amount > 0) {
                        // Use the specific amount from the matching discount application
                        const formattedDiscount = formatMoney(couponDiscount.total_allocated_amount).replace(' USD', '');
                        
                        // Update tag to show code and its specific amount
                        elements.tagText.textContent = `${savedDiscount} - ${formattedDiscount} off`;
                    } else {
                        // Special case for welcome5
                        if (savedDiscount.toLowerCase() === 'welcome5') {
                            elements.tagText.textContent = `${savedDiscount} - $5.00 off`;
                        } else {
                            // For other codes, just show the code name
                            elements.tagText.textContent = savedDiscount;
                        }
                    }
                    
                    elements.tag.style.display = 'inline-flex';
                } else if (hasDiscount) {
                    // If no valid discount codes in cart but there is a discount, show automatic discount
                    elements.tagText.textContent = 'Automatic discount';
                    elements.tag.style.display = 'inline-flex';
                } else {
                    // If no valid discount codes in cart and no discount, hide the tag
                    elements.tag.style.display = 'none';
                }
            } else if (hasDiscount) {
                // If no discount codes in cart data but there's a discount amount
                elements.tagText.textContent = 'Automatic discount';
                elements.tag.style.display = 'inline-flex';
            } else {
                // If no active discount codes in cart, hide the tag
                elements.tag.style.display = 'none';
            }
        } else if (elements.tag && hasDiscount) {
            // If there's a discount but no saved code, show automatic discount
            if (elements.tagText) elements.tagText.textContent = 'Automatic discount';
            elements.tag.style.display = 'inline-flex';
        } else if (elements.tag) {
            // If no discount code, hide the tag
            elements.tag.style.display = 'none';
        }
        
        // Hide all discount lines initially
        const allDiscountLines = discountContainer.querySelectorAll('.ajaxcart__discount-line');
        allDiscountLines.forEach(line => {
            line.classList.add('hidden-discount-line');
        });
        
        // Calculate total discount amount (difference between original and final price)
        const totalDiscountAmount = cartData.original_total_price - cartData.total_price;
        
        // Get cart discount applications
        const cartDiscounts = cartData.cart_level_discount_applications || [];
        
        // Variables to track discounts for the total
        let totalProductDiscount = 0;
        let totalCouponDiscount = 0;
        let totalOtherDiscounts = 0;
        let hasAnyDiscounts = false;
        
        // Check for product-level discounts first
        if (settings.showItemsDiscount && cartData.items && cartData.items.length > 0) {
            // Calculate total product discount
            totalProductDiscount = 0;
            
            // Loop through items to find discounted products
            cartData.items.forEach(item => {
                // Calculate the discount on this item (if any)
                const itemDiscount = (item.original_line_price || 0) - (item.final_line_price || 0);
                if (itemDiscount > 0) {
                    totalProductDiscount += itemDiscount;
                }
            });
            
            // If we have product discounts, show them
            if (totalProductDiscount > 0) {
                hasAnyDiscounts = true;
                
                // Update the product discount line
                const discountPercent = Math.round((totalProductDiscount / Math.max(cartData.original_total_price, 1)) * 100);
                updateDiscountLineContent(
                    discountContainer,
                    'product-discount-line',
                    `${discountPercent}% Discount`,
                    formatMoney(totalProductDiscount)
                );
            }
        }
        
        // If we have a coupon code, show it
        if (settings.showCouponDiscount && savedDiscount) {
            // Find the specific discount for the coupon
            let couponDiscount = null;
            let couponAmount = 0;
            
            // Try to find the discount application that matches the coupon code
            for (const discount of cartDiscounts) {
                if (discount && discount.title && discount.title.toLowerCase().includes(savedDiscount.toLowerCase())) {
                    couponDiscount = discount;
                    couponAmount = discount.total_allocated_amount || 0;
                    break;
                }
            }
            
            // If we couldn't find a matching discount, use a fallback amount
            if (!couponDiscount && savedDiscount && savedDiscount.toLowerCase() === 'welcome5') {
                couponAmount = 500; // $5.00 in cents
            }
            
            // Only show the coupon line if we have an amount
            if (couponAmount > 0) {
                hasAnyDiscounts = true;
                totalCouponDiscount = couponAmount;
                
                // Update the coupon discount line
                updateDiscountLineContent(
                    discountContainer,
                    'coupon-discount-line',
                    `${savedDiscount} Discount`,
                    formatMoney(couponAmount)
                );
            }
        }
        
        // Add lines for other automatic discounts
        cartDiscounts.forEach(discount => {
            // Skip if this discount is the coupon discount we already displayed
            // or if it appears to be a product discount
            if (
                !discount || !discount.title || 
                (savedDiscount && discount.title.toLowerCase().includes(savedDiscount.toLowerCase())) ||
                (discount.title.toLowerCase().includes('off'))
            ) {
                return;
            }
            
            hasAnyDiscounts = true;
            totalOtherDiscounts += discount.total_allocated_amount || 0;
            
            // Update the automatic discount line
            updateDiscountLineContent(
                discountContainer,
                'automatic-discount-line',
                discount.title,
                formatMoney(discount.total_allocated_amount || 0)
            );
        });
        
        // Add a total discounts line if there are any discounts and the setting is enabled
        if (settings.showDiscountTotal && hasAnyDiscounts) {
            // Use the actual total discount from cart data
            const totalDiscountsAmount = totalDiscountAmount || 0;
            
            // If we have a total discount amount greater than 0, show the total line
            if (totalDiscountsAmount > 0) {
                // Update the total discount line
                updateDiscountLineContent(
                    discountContainer,
                    'discount-total-line',
                    'Total Savings',
                    formatMoney(totalDiscountsAmount)
                );
            }
        }
        
        // Update the cart totals
        const subtotalElements = document.querySelectorAll('.ajaxcart__subtotal');
        if (subtotalElements.length > 0) {
            const formattedPrice = formatMoney(cartData.total_price);
            subtotalElements.forEach(element => {
                element.textContent = formattedPrice;
            });
        }
        
        // Try updating prices for line items
        if (cartData.items && cartData.items.length > 0) {
            const allPriceElements = document.querySelectorAll('#mini-cart .price--end, #mini-cart .price-list .price');
            
            if (allPriceElements.length > 0) {
                let priceIndex = 0;
                
                cartData.items.forEach((item, index) => {
                    if (priceIndex < allPriceElements.length) {
                        const formattedItemPrice = formatMoney(item.final_line_price);
                        allPriceElements[priceIndex].textContent = formattedItemPrice;
                        priceIndex++;
                    }
                });
            }
        }
    }
    
    // Helper function to update a specific discount line
    function updateDiscountLineContent(container, className, label, amount) {
        // Find the line or create it if needed
        let line = container.querySelector(`.${className}`);
        if (!line) {
            line = createDiscountLine(container, className, label);
        }
        
        // Update content
        const labelEl = line.querySelector('.discount-label');
        const amountEl = line.querySelector('.discount-amount');
        
        if (labelEl) labelEl.textContent = label;
        if (amountEl) amountEl.textContent = '-' + amount;
        
        // Show the line
        line.classList.remove('hidden-discount-line');
        
        return line;
    }
    
    // Helper function to format money - use a simpler version
    function formatMoney(cents) {
        if (typeof cents === 'string') cents = cents.replace('.', '');
        const dollars = parseFloat(cents) / 100;
        const formatted = '$' + dollars.toFixed(2) + ' USD';
        return formatted;
    }
    
    // Function to check for active discounts and update UI accordingly
    function checkForActiveDiscounts() {
        // If an item removal is in progress, wait briefly before checking discounts
        if (localStorage.getItem('cart_item_removal_in_progress')) {
            setTimeout(checkForActiveDiscounts, 500);
            return;
        }
        
        // First check the cart itself to see if there are any discounts applied
        fetchCartContents().then(cartData => {
            // Check if there are any discounts applied
            const hasDiscounts = cartData.total_discount > 0 || 
                (cartData.cart_level_discount_applications && 
                 cartData.cart_level_discount_applications.length > 0) ||
                (cartData.discount_codes && cartData.discount_codes.length > 0 && 
                 cartData.discount_codes.some(code => code.applicable !== false && code.code.toLowerCase() !== 'clear'));
                 
            // Get stored discount code
            let discountCode = localStorage.getItem('shopify_discount_code');
            let foundDiscountInCart = false;
            
            // First try to get discount code from discount_codes array (most reliable)
            if (cartData.discount_codes && cartData.discount_codes.length > 0) {
                // Filter out non-applicable discount codes and 'clear' codes
                const validDiscounts = cartData.discount_codes.filter(code => 
                    code.applicable !== false && 
                    code.code && 
                    code.code.toLowerCase() !== 'clear'
                );
                
                if (validDiscounts.length > 0) {
                    const firstDiscount = validDiscounts[0];
                    if (firstDiscount && firstDiscount.code) {
                        discountCode = firstDiscount.code;
                        foundDiscountInCart = true;
                        localStorage.setItem('shopify_discount_code', discountCode);
                    }
                } else {
                    // Clear localStorage if we have no valid discount codes
                    if (discountCode) {
                        localStorage.removeItem('shopify_discount_code');
                        discountCode = null;
                    }
                }
            }
            // If no discount code found in discount_codes, try from cart_level_discount_applications
            else if (hasDiscounts && cartData.cart_level_discount_applications) {
                // Look for cart discount applications
                const discountApp = cartData.cart_level_discount_applications[0];
                if (discountApp && discountApp.title) {
                    // Extract discount code from the title (usually appears as "DISCOUNT_CODE - description")
                    const codeMatch = discountApp.title.match(/^([A-Z0-9_\-]+)/i);
                    if (codeMatch && codeMatch[1]) {
                        discountCode = codeMatch[1];
                        foundDiscountInCart = true;
                        localStorage.setItem('shopify_discount_code', discountCode);
                    }
                }
            }
            
            // Update UI based on discount state
            if (hasDiscounts) {
                // Determine whether the discount is automatic (quantity-based) or from a coupon code
                let isAutomaticDiscount = false;
                
                // If we don't have a valid discount code but there is a discount, it's automatic
                if (!discountCode && cartData.total_discount > 0) {
                    isAutomaticDiscount = true;
                }
                
                // If there are cart-level discounts but no code in discount_codes, it's automatic
                if (!foundDiscountInCart && cartData.cart_level_discount_applications && 
                    cartData.cart_level_discount_applications.length > 0) {
                    // Check if the discount seems automatic (based on title patterns)
                    const discountApp = cartData.cart_level_discount_applications[0];
                    if (discountApp && discountApp.title && 
                        (discountApp.title.toLowerCase().includes('quantity') || 
                         discountApp.title.toLowerCase().includes('automatic') ||
                         discountApp.title.match(/^\d+% off/i) ||
                         discountApp.title.match(/^\$\d+ off/i))) {
                        isAutomaticDiscount = true;
                    }
                }
                
                if (isAutomaticDiscount) {
                    // For automatic discounts, update the tag but not the input field
                    if (elements.tagText && elements.tag) {
                        elements.tagText.textContent = "Automatic discount";
                        elements.tag.style.display = 'inline-flex';
                    }
                    
                    // Show remove button for automatic discounts too
                    if (elements.removeBtn) {
                        elements.removeBtn.style.display = 'block';
                    }
                    
                    // Keep the input field empty for automatic discounts
                    if (elements.input) {
                        elements.input.value = '';
                    }
                    
                    // Don't show success message for automatic discounts
                    if (elements.message) {
                        elements.message.textContent = '';
                    }
                } else {
                    // For coupon codes, show the code in input and update UI
                    updateUIWithDiscount(discountCode || '');
                }
                
                updateCartDisplay(cartData);
            } else {
                // Check if we have a saved discount code that's not reflected in the cart
                if (discountCode && !foundDiscountInCart) {
                    // Try to apply the saved discount code
                    applyDiscountCode(discountCode, true);
                } else {
                    // No discounts, clear UI
                    clearDiscountUI();
                }
            }
        }).catch(error => {
            console.error('Error checking for active discounts:', error);
            // Error fetching cart - try to use localStorage as fallback
            const savedDiscount = localStorage.getItem('shopify_discount_code');
            if (savedDiscount && elements.tagText && elements.tag) {
                elements.tagText.textContent = savedDiscount;
                elements.tag.style.display = 'inline-flex';
            }
        });
    }
    
    // Apply discount handler
    function handleApplyDiscount() {
        const discountCode = elements.input ? elements.input.value.trim() : '';
        if (!discountCode) {
            showMessage('Please enter a discount code', '#cc0000');
            return;
        }
        
        applyDiscountCode(discountCode);
    }
    
    // Apply discount code to cart
    function applyDiscountCode(code, silent = false) {
        if (!silent) {
            // Show loading state
            if (elements.applyBtn) {
                elements.applyBtn.textContent = 'Applying...';
                elements.applyBtn.disabled = true;
            }
        }
        
        // Save discount code
        localStorage.setItem('shopify_discount_code', code);
        
        // Apply discount using the cart API
        fetch('/discount/' + encodeURIComponent(code))
            .then(response => {
                if (!silent && elements.applyBtn) {
                    elements.applyBtn.disabled = false;
                    elements.applyBtn.textContent = 'Apply';
                }
                
                if (response.ok) {
                    return fetchCartContents();
                } else {
                    throw new Error('Invalid discount code');
                }
            })
            .then(cartData => {
                if (!silent) {
                    showMessage('Discount code applied successfully', '#008800');
                    
                    // Close the coupon form if applying manually
                    const closeButton = document.querySelector('#mini-cart-coupon [data-action="close"]');
                    if (closeButton) {
                        closeButton.click();
                    }
                }
                
                updateUIWithDiscount(code);
                updateCartDisplay(cartData);
            })
            .catch(error => {
                console.error('Error in applyDiscountCode:', error);
                
                if (!silent) {
                    showMessage(error.message, '#cc0000');
                }
                
                localStorage.removeItem('shopify_discount_code');
                
                if (!silent && elements.applyBtn) {
                    elements.applyBtn.disabled = false;
                    elements.applyBtn.textContent = 'Apply';
                }
            });
    }
    
    // Remove discount code
    function removeDiscountCode() {
        // Clear from localStorage
        localStorage.removeItem('shopify_discount_code');
        
        // Show loading state
        if (elements.removeBtn && elements.removeBtn.style.display !== 'none') {
            elements.removeBtn.textContent = 'Removing...';
            elements.removeBtn.disabled = true;
        }
        
        // Remove discount from cart
        fetch('/discount/clear')
            .then(response => {
                if (response.ok) {
                    return fetchCartContents();
                } else {
                    throw new Error('Could not remove discount');
                }
            })
            .then(cartData => {
                clearDiscountUI();
                updateCartDisplay(cartData);
            })
            .catch(error => {
                console.error('Error removing discount code:', error);
                if (elements.removeBtn) {
                    elements.removeBtn.textContent = 'Remove Discount';
                    elements.removeBtn.disabled = false;
                }
                
                // Even on error, make sure UI is cleared
                clearDiscountUI();
            });
    }
    
    // Helper function to update UI with discount
    function updateUIWithDiscount(code) {
        // Only update the input field if it's a real coupon code (not "Automatic discount")
        if (elements.input && code !== 'Automatic discount') {
            elements.input.value = code;
        }
        
        if (elements.removeBtn) {
            elements.removeBtn.style.display = 'block';
        }
        
        if (elements.tagText && elements.tag) {
            elements.tagText.textContent = code;
            elements.tag.style.display = 'inline-flex';
        }
        
        // Only show success message for actual codes, not automatic discounts
        if (code !== 'Automatic discount') {
            showMessage('Discount code applied: ' + code, '#008800');
        }
    }
    
    // Helper function to clear discount UI
    function clearDiscountUI() {
        if (elements.input) elements.input.value = '';
        if (elements.message) elements.message.textContent = '';
        if (elements.removeBtn) {
            elements.removeBtn.style.display = 'none';
            elements.removeBtn.textContent = 'Remove Discount';
            elements.removeBtn.disabled = false;
        }
        if (elements.tag) elements.tag.style.display = 'none';
        if (elements.tagText) elements.tagText.textContent = '';
    }
    
    // Helper function to show messages
    function showMessage(text, color) {
        if (elements.message) {
            elements.message.textContent = text;
            elements.message.style.color = color;
        }
    }
    
    // Fetch current cart contents
    function fetchCartContents() {
        return fetch('/cart.js')
            .then(response => response.json())
            .then(data => {
                // Handle possible data issues
                if (!data) {
                    throw new Error('Empty cart data received');
                }
                
                // Ensure required properties exist to avoid errors
                data.items = data.items || [];
                data.cart_level_discount_applications = data.cart_level_discount_applications || [];
                data.discount_codes = data.discount_codes || [];
                data.original_total_price = data.original_total_price || 0;
                data.total_price = data.total_price || 0;
                data.total_discount = data.total_discount || 0;
                
                return data;
            })
            .catch(error => {
                console.error('Error fetching cart:', error);
                // Return a minimal valid cart object to prevent further errors
                return {
                    items: [],
                    cart_level_discount_applications: [],
                    discount_codes: [],
                    original_total_price: 0,
                    total_price: 0,
                    total_discount: 0
                };
            });
    }
    
    // Function to preserve the discount section during updates
    function preserveDiscountSection() {
        const footerPriceContainer = document.querySelector('.ajaxcart__footer-price');
        if (!footerPriceContainer) return;
        
        // Get existing discount container
        const discountContainer = footerPriceContainer.querySelector('.ajaxcart__discount-container');
        if (!discountContainer) return;
        
        // If there are no discount lines, don't bother preserving
        const hasDiscountLines = discountContainer.querySelectorAll('.ajaxcart__discount-line:not(.hidden-discount-line)').length > 0;
        if (!hasDiscountLines) return;
        
        // Store the HTML in sessionStorage for retrieval
        sessionStorage.setItem('discount_section_html', discountContainer.innerHTML);
        sessionStorage.setItem('has_discount_content', 'true');
        
        // Create a clone that stays visible during the transition
        const cloneContainer = document.createElement('div');
        cloneContainer.className = 'ajaxcart__discount-container discount-clone-container';
        cloneContainer.innerHTML = discountContainer.innerHTML;
        
        // Remove any existing clones
        const existingClone = footerPriceContainer.querySelector('.discount-clone-container');
        if (existingClone) existingClone.remove();
        
        // Add the clone to the DOM
        footerPriceContainer.appendChild(cloneContainer);
    }
    
    // Function to restore the discount section after updates
    function restoreDiscountSection() {
        const footerPriceContainer = document.querySelector('.ajaxcart__footer-price');
        if (!footerPriceContainer) return;
        
        // Get current discount container
        let discountContainer = footerPriceContainer.querySelector('.ajaxcart__discount-container:not(.discount-clone-container)');
        if (!discountContainer) {
            discountContainer = setupDiscountContainer();
            if (!discountContainer) return;
        }
        
        // Check if we have stored content
        const hasStoredContent = sessionStorage.getItem('has_discount_content') === 'true';
        if (hasStoredContent) {
            const storedHTML = sessionStorage.getItem('discount_section_html');
            if (storedHTML) {
                discountContainer.innerHTML = storedHTML;
            }
        }
        
        // Remove the clone immediately without waiting
        const cloneContainer = footerPriceContainer.querySelector('.discount-clone-container');
        if (cloneContainer) {
            cloneContainer.remove();
        }
    }
});